export function renderNavbar() {
  return `
    <header class="site-header">
      <a class="brand" href="/" data-route aria-label="womyn.network home">
        <img src="${new URL('../assets/branding/logo1.png', import.meta.url).href}" alt="" aria-hidden="true">
        <span>womyn.network</span>
      </a>

      <button
        class="menu-toggle"
        type="button"
        aria-controls="primaryNav"
        aria-expanded="false"
      >
        <span></span>
        <span></span>
        <span></span>
        <span class="sr-only">Toggle navigation</span>
      </button>

      <nav class="nav" aria-label="Primary navigation">
        <div class="nav-menu" id="primaryNav">
          <a href="/#vision" data-route>Vision</a>
          <a href="/#pillars" data-route>Pillars</a>
          <a href="/#founding" data-route>Founding Myns</a>
          <a href="/#faq" data-route>FAQ</a>
          <a href="/contact" data-route>Contact Us</a>
          <a class="mobile-menu-cta" href="/#join" data-route>Join the Waitlist</a>
        </div>
      </nav>

      <a class="nav-cta" href="/#join" data-route>Join the Waitlist</a>
    </header>
  `;
}
